// import Slide from "components/Slide"
import SwiperBanner from "components/SwiperBanner"
// import { api } from "apiServer"
import { Layout } from "components/common"
import TypeEvent from "utils/TypeEvent"
import SwiperLive from "components/SwiperLive"
import SwiperVod from "components/SwiperVod"
import SwiperLiveShow from "components/SwiperLiveShow"
import SwiperChannel from "components/SwiperChannel"
import SwiperTopic from "components/SwiperTopic"
import SwiperLeague from "components/SwiperLeague"
import { getPropsHomePage } from "lib/dataStore"
import { useEffect, useState } from "react"
import { trackGA } from "lib/func"
import Recommend from "components/Recommend"
import BannerService from "components/BannerService"
import { getAccessToken, parseCookies } from "lib/Cookies"
import dynamic from "next/dynamic"
import Skeleton from "react-loading-skeleton" // Install this library
import useStore from "components/ui/Context"

const Slide = dynamic(() => import("components/Slide"), { ssr: false })

function renderBlock(type_block, item, leagues, backgrounds, isCollapsed) {
  switch (type_block) {
    case TypeEvent.BANNER:
      return <SwiperBanner {...item} isCollapsed={isCollapsed} />
    case TypeEvent.LIVE:
      return <SwiperLive {...item} isCollapsed={isCollapsed} />
    case TypeEvent.LIVESHOW:
      return <SwiperLiveShow {...item} isCollapsed={isCollapsed} />
    case TypeEvent.TOPIC:
      return <SwiperTopic {...item} isCollapsed={isCollapsed} />
    case TypeEvent.STORY:
      return <SwiperVod {...item} isCollapsed={isCollapsed} />
    case TypeEvent.LEAGUE:
      return <SwiperLeague item={item} leagues={leagues} isCollapsed={isCollapsed} />
    case TypeEvent.CHANNEL:
      return <SwiperChannel {...item} isCollapsed={isCollapsed} />
    case TypeEvent.VOD:
    case TypeEvent.RESUME:
      return <SwiperVod {...item} isCollapsed={isCollapsed} />
    case TypeEvent.SERVICE:
      return <BannerService item={backgrounds?.find((background) => background.type_bg === 2)} />
    default:
      return <></>
  }
}

function Component({ screenblocks, slides, leagues, backgrounds, recommends, isCollapsed }) {
  const [screenblock, setScreenblock] = useState(screenblocks)
  const [slide, setSlide] = useState(slides)
  const [league, setLeague] = useState(leagues)
  const [background, setBackground] = useState(backgrounds)
  const [recommend, setRecommend] = useState(recommends)
  const [loading, setLoading] = useState(true)
  const { userInfo } = useStore()
  const accessToken = getAccessToken()

  useEffect(() => {
    trackGA("Trang chủ", "HOME_TAB")
    setLoading(false)
  }, [])

  useEffect(() => {
    const recallPropsHomePage = async () => {
      const pageProps = await getPropsHomePage(accessToken, "client")
      setScreenblock(pageProps?.screenblocks)
      setSlide(pageProps?.slides)
      setLeague(pageProps?.leagues)
      setBackground(pageProps?.backgrounds)
      setRecommend(pageProps?.recommends)
    }
    if (userInfo) recallPropsHomePage()
  }, [userInfo])

  if (loading)
    return (
      <section className="mb-12">
        <Skeleton height={500} className="mb-4" />
        <Skeleton height={350} className="mb-4" />
        <Skeleton height={350} className="mb-4" />
        <Skeleton height={230} className="mb-4" />
        <Skeleton height={230} className="mb-4" />
      </section>
    )

  return (
    <section className="mb-12">
      <Slide slides={slide} isCollapsed={isCollapsed} />
      <div className="pt-0 mx-auto max-sm:mt-8 max-lg:mt-5 mt-[54px] overflow-x-hidden max-lg:pl-4 max-[1199.5px]:pl-8 flex flex-col gap-[60px] max-md:gap-[36px] max-lg:gap-[46px]">
        <Recommend items={recommend} />
        {/* <SpecialEvent item={screenblocks[3]} /> */}
        {screenblock?.length > 0 &&
          screenblock?.map((item) => {
            const { id, type_block } = item
            return <div key={id}>{renderBlock(type_block, item, league, background, isCollapsed)}</div>
          })}
      </div>
    </section>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps(context) {
  let pageProps = {
    screenblocks: [],
    slides: [],
    leagues: [],
    backgrounds: [],
    recommends: []
  }

  const cookies = parseCookies(context.req?.headers?.cookie || "")
  const accessToken = cookies.accessToken || null

  try {
    pageProps = await getPropsHomePage(accessToken)
  } catch (error) {
    console.log(error)
  }
  return { props: pageProps }
}
